import { ResponsivePie } from '@nivo/pie'
import React from 'react'
import styled from 'styled-components/macro'

const formatCurrency = value => {
  const parsed = Number.parseFloat(value)
  const amount = Number.isNaN(parsed) ? 0 : parsed
  return `£${amount.toFixed(2)}`
}

const PieTooltip = ({ datum }) => {
  return (
    <TooltipContainer>
      <TooltipLabel style={{ color: datum.color }}>{datum.label}</TooltipLabel>
      <TooltipValue>{formatCurrency(datum.value)}</TooltipValue>
    </TooltipContainer>
  )
}

const BarChart = ({ data, types }) => {
  return (
    <ChartContainer>
      <ResponsivePie
        data={data}
        keys={types}
        indexBy='supplier'
        margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
        innerRadius={0.02}
        padAngle={0.7}
        cornerRadius={4}
        activeOuterRadiusOffset={8}
        borderWidth={2}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 0.2]],
        }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor='#6b6b6b'
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color' }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor='#ffffff'
        arcLabelsRadiusOffset={0.65}
        tooltip={PieTooltip}
        legends={[]}
        theme={{
          tooltip: {
            container: {
              background: '#ffffff',
              color: '#333',
              fontSize: '13px',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
              border: '1px solid rgba(0, 0, 0, 0.08)',
              padding: '10px 12px',
            },
          },
        }}
      />
    </ChartContainer>
  )
}

const ChartContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const TooltipLabel = styled.span`
  font-weight: 600;
  font-size: 13px;
`

const TooltipValue = styled.strong`
  font-size: 14px;
  color: #1a1a1a;
`

export default BarChart
